import React, { Component } from "react";
import AntdCalendar, {CalendarProps} from 'antd/lib/calendar';
import 'antd/lib/calendar/style';

export default class Calendar extends Component<CalendarProps> {
    render() {
        return (
          <AntdCalendar {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/calendar/index.tsx